require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-swift-two-day-intensive-course-starts-june-28.json") })
        }
      }, "path---blog-swift-two-day-intensive-course-starts-june-28");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-swift-two-day-intensive-course-starts-june-28!./.cache/json/blog-swift-two-day-intensive-course-starts-june-28.json
// module id = 1048
// module chunks = 231608221292675